import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import { post } from '../../api/api';

export const updateManyApplicationStatusSubscription = (
  params: ApplicationStatusSubscriptionUpdateMany,
) =>
  createGenericDispatcher<ApplicationStatusSubscription>({
    name: 'UPDATE_MANY_APPLICATION_STATUS_SUBSCRIPTION',
    loadFunction: () =>
      post('/application-status-subscription/update-many', {
        body: JSON.stringify(params),
      }),
    args: { jobId: params.jobId, orgId: params.orgId },
  });
